module.exports = __webpack_public_path__ + "resources/img/img_ai_fashion2.e73f3dbf6002ece1b28f2844268ed099.png";